jQuery('.search-icon, .search-icon-narrow').on('click', function () {
    jQuery('.site-search').toggleClass('hidden');
    jQuery('.search-field').focus();
});